module.exports = __webpack_public_path__ + "static/media/Sirius Black 2.d3d3d4dc.jpg";